export const hiringManagerCandidatesJobsConstants = {
  //all mentors applied on job
  GET_SUGGESTED_CANDIDATES_HIRING_MANAGER_ACTION_REQUEST:
    "GET_SUGGESTED_CANDIDATES_HIRING_MANAGER_ACTION_REQUEST",
  GET_SUGGESTED_CANDIDATES_HIRING_MANAGER_ACTION_SUCCESS:
    "GET_SUGGESTED_CANDIDATES_HIRING_MANAGER_ACTION_SUCCESS",
  GET_SUGGESTED_CANDIDATES_HIRING_MANAGER_ACTION_FAILURE:
    "GET_SUGGESTED_CANDIDATES_HIRING_MANAGER_ACTION_FAILURE",
    
  // all applied candidates 
  ALL_APPLIED_CANDIDATES_LIST_REQUEST: "ALL_APPLIED_CANDIDATES_LIST_REQUEST",
  ALL_APPLIED_CANDIDATES_LIST_SUCCESS: "ALL_APPLIED_CANDIDATES_LIST_SUCCESS",
  ALL_APPLIED_CANDIDATES_LIST_FAILURE: "ALL_APPLIED_CANDIDATES_LIST_FAILURE",
};
